
import { createContext, useContext } from 'react'
import userStore from '@/stores/userStore'


const RootContext = createContext<{
  userStore: ReturnType<typeof userStore>
}>({ 
  userStore: {} as ReturnType<typeof userStore>,
})
const RootProvider = RootContext.Provider

const useRootStore = () => {
  return useContext(RootContext)
}

export {
  RootContext,
  RootProvider,
  useRootStore,
}